import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
export default function uploadThumbWrapper(UploadThumb) {
    var _React_Component, _UploadThumbWrapper;
    return _UploadThumbWrapper = class UploadThumbWrapper extends (_React_Component = React.Component) {
        render() {
            const { componentData } = this.props;
            return /*#__PURE__*/ React.createElement(UploadThumb, {
                fileId: componentData.fileId
            });
        }
    }, _define_property(_UploadThumbWrapper, "customClassName", (componentData, theme, styles, isMobile)=>theme['uploadDndPlugin']), _UploadThumbWrapper;
}
